module.exports = __webpack_public_path__ + "static/media/benefits2.da2256c5.jpg";